module.exports = __webpack_public_path__ + "img/hr.3e56776d.svg";